"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var ReceiptLine_1 = require("../model/ReceiptLine");

var ReceiptLineConverter_1 = require("./ReceiptLineConverter");
/**
 * @author VRu
 */


var ReceiptLineConverterImpl =
/*#__PURE__*/
function (_ReceiptLineConverter) {
  _inherits(ReceiptLineConverterImpl, _ReceiptLineConverter);

  function ReceiptLineConverterImpl() {
    _classCallCheck(this, ReceiptLineConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ReceiptLineConverterImpl).apply(this, arguments));
  }

  _createClass(ReceiptLineConverterImpl, [{
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        externalId: source.externalId,
        transactionId: source.transactionId,
        line: source.line,
        productId: conversions.toDocumentReferenceId(source.productId),
        siteId: conversions.toDocumentReferenceId(source.siteId),
        promotionId: !source.promotionId ? null : conversions.toDocumentReferenceId(source.promotionId),
        cashdeskId: source.cashdeskId,
        datetime: conversions.fromDate(source.datetime),
        amount: conversions.fromBigNumber(source.amount),
        saleValueWithoutVat: source.saleValueWithoutVat ? conversions.fromBigNumber(source.saleValueWithoutVat) : null,
        vat: source.vat ? conversions.fromBigNumber(source.vat) : null,
        created: conversions.fromDate(source.created),
        stateFlags: source.stateFlags.serialize()
      });
      return result;
    }
  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new ReceiptLine_1.ReceiptLine(ReceiptLine_1.ReceiptLine.schema.id.valueOf(conversions.documentToClassId(source)), ReceiptLine_1.ReceiptLine.schema.externalId.valueOfField(source), ReceiptLine_1.ReceiptLine.schema.transactionId.valueOfField(source), ReceiptLine_1.ReceiptLine.schema.line.valueOfField(source), ReceiptLine_1.ReceiptLine.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), ReceiptLine_1.ReceiptLine.schema.siteId.valueOf(conversions.toClassReferenceId(source.siteId)), !source.promotionId ? null : ReceiptLine_1.ReceiptLine.schema.promotionId.valueOf(conversions.toClassReferenceId(source.promotionId)), ReceiptLine_1.ReceiptLine.schema.cashdeskId.valueOfField(source), ReceiptLine_1.ReceiptLine.schema.datetime.valueOf(conversions.toDate(source.datetime)), ReceiptLine_1.ReceiptLine.schema.amount.valueOf(conversions.toBigNumber(source.amount)), ReceiptLine_1.ReceiptLine.schema.saleValueWithoutVat.valueOf(source.saleValueWithoutVat ? conversions.toBigNumber(source.saleValueWithoutVat) : null), ReceiptLine_1.ReceiptLine.schema.vat.valueOf(source.vat ? conversions.toBigNumber(source.vat) : null), ReceiptLine_1.ReceiptLine.schema.created.valueOf(conversions.toDate(source.created)), conversions.asFlagSet(source.stateFlags, EntityStateFlag_1.EntityStateFlag));
    }
  }]);

  return ReceiptLineConverterImpl;
}(ReceiptLineConverter_1.ReceiptLineConverter);

exports.ReceiptLineConverterImpl = ReceiptLineConverterImpl;